module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navs l_o_btm"
  }, [_c('router-link', {
    attrs: {
      "to": "/opera/"
    }
  }, [_c('div', {
    staticClass: "nav"
  }, [_c('i', {
    staticClass: "iconfont icon-shouye ",
    class: {
      active: _vm.sta == '1', 'icon-shouyeH': _vm.sta == '1',
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('footNav_home')))])])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/opera/info"
    }
  }, [_c('div', {
    staticClass: "nav"
  }, [_c('i', {
    staticClass: "iconfont icon-xiaoxi2",
    class: {
      active: _vm.sta == '2', 'icon-xiaoxiH': _vm.sta == '2',
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('footNav_info')))]), _vm._v(" "), (_vm.infoCount > 0) ? _c('div', {
    staticClass: "message"
  }, [_vm._v(_vm._s(_vm.infoCount))]) : _vm._e()])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/opera/center"
    }
  }, [_c('div', {
    staticClass: "nav"
  }, [_c('i', {
    staticClass: "iconfont icon-gerenzhongxin",
    class: {
      active: _vm.sta == '3', 'icon-gerenzhongxinH': _vm.sta == '3'
    }
  }), _vm._v(" "), _c('p', [_c('span', [_vm._v(_vm._s(_vm.$t('footNav_center')))])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-a933f282","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/operaCommon/footNav.vue
// module id = 1828
// module chunks = 107